/***
 *
 *   STATUS WORKFLOW COLUMN STYLES
 *   Token-based drag states for light + dark (replaces #b6c4f6 / #4eedd0).
 *
 **********/

const Style = {
    container:
        'flex flex-col overflow-hidden rounded-lg border border-border/25 bg-muted/20',
    strip: 'w-full',
    header:
        'flex items-center justify-between gap-2 rounded-t-lg bg-muted/50 px-3 py-2.5',
    headerRow: 'flex min-w-0 flex-1 items-center gap-2',
    swatch: 'block h-2.5 w-2.5 shrink-0 rounded-full border border-black/10 dark:border-white/15',
    title: 'truncate text-xs font-semibold uppercase tracking-wide text-text-secondary',
    count: 'shrink-0 text-xs tabular-nums text-text-muted',
    actionBtn:
        'shrink-0 rounded-md p-1 text-text-muted transition-colors hover:bg-muted hover:text-text-primary',
    droppable: 'rounded-b-lg p-2 transition-colors',
    droppableStrip: 'flex min-h-[3.5rem] flex-wrap gap-2',
    droppableBucket: 'min-h-[7rem] flex-1 space-y-1.5',
    droppableActive:
        'border-primary-400/40 bg-primary-50/50 dark:border-primary-600/50 dark:bg-primary-900/20',
    empty: 'py-3 text-center text-xs italic text-text-muted/60',
    statusItem:
        'flex items-center gap-1.5 rounded-md border border-border/60 bg-surface px-2 py-1.5 text-xs shadow-sm',
    statusStrip: 'inline-flex',
    statusFromStrip: 'min-w-[10rem]',
    statusDragging: 'shadow-lg ring-2 ring-primary-400/30 dark:ring-primary-500/40',
    grip: 'shrink-0 text-text-muted',
    statusLabel: 'truncate text-text-primary',
};

export default Style;
